export default "__VITE_ASSET__C7shH5rD__"